import "./education.css";
import { ImLocation } from "react-icons/im";
import { useRef, useEffect } from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { MdWork } from "react-icons/md";
import { AiTwotoneStar } from "react-icons/ai";
import WorkIcon from "@material-ui/icons/Work";
import SchoolIcon from "@material-ui/icons/School";
import StarRateIcon from "@material-ui/icons/StarRate";
import School from "@material-ui/icons/School";

export const Education = () => {
  const masaiLocation = () => {
    window.open(
      `https://www.google.com/maps/place/Masai+School/@12.9341753,77.6106009,17z/data=!3m1!4b1!4m5!3m4!1s0x3bae1525f3226a65:0x9d0c72b3bd41f2ef!8m2!3d12.9343003!4d77.6127227`,
      `_blank`
    );
  };

  return (
    <div className="aboutContainer" id="education">
      <div className="headingBtn">
        <p className="heading">My TimeLine</p>
        <div></div>
      </div>

      {/* <VerticalTimeline>

                <VerticalTimelineElement
                    contentStyle={{
                        border: "1px solid transparent",
                        backgroundColor: "transparent",
                        textAlign: "center",
                        boxShadow: "0 0 5px seagreen, 0 0 30px seagreen"
                    }}
                    textClassName="timeline_txt"
                    contentArrowStyle={{
                        borderRight: "16px solid white",
                    }}
                    iconStyle={{
                        backgroundColor: '',
                        color: `deeppink`,
                    }}
                    className="vertical-timeline-element--work"
                    date="2016 - 2018"
                    icon={<SchoolIcon />}
                    data-aos="flip-left"
                >
                    <h3 className="vertical-timeline-element-title">Hooghly Girls' High School</h3>
                    <h4 className="vertical-timeline-element-subtitle">Hooghly, West Bengal</h4>
                    <p>
                        Higher Secondary(Science)
                    </p>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="2018 - 2020"
                    contentStyle={{
                        border: "1px solid transparent",
                        backgroundColor: "transparent",
                        textAlign: "center",
                        boxShadow: "0 0 5px deeppink, 0 0 30px deeppink"
                    }}
                    textClassName="timeline_txt"
                    contentArrowStyle={{
                        borderRight: "16px solid  white",
                    }}
                    iconStyle={{
                        backgroundColor: '',
                        color: `deeppink`,
                    }}
                    icon={<SchoolIcon />}
                >
                    <h3 className="vertical-timeline-element-title">Preparing for Govt. Jobs</h3>
                    <h4 className="vertical-timeline-element-subtitle">SSC, RBI</h4>
                    <p>
                        Self Study
                    </p>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="Jan 2021 - Sep 2021"
                    contentStyle={{
                        border: "1px solid transparent",
                        backgroundColor: "transparent",
                        textAlign: "center",
                        boxShadow: "0 0 5px seagreen, 0 0 30px seagreen"
                    }}
                    textClassName="timeline_txt"
                    contentArrowStyle={{
                        borderRight: "16px solid  white",
                    }}
                    iconStyle={{
                        backgroundColor: '',
                        color: `deeppink`,
                    }}
                    icon={<WorkIcon />}
                >
                    <h3 className="vertical-timeline-element-title">Freelancing</h3>
                    <h4 className="vertical-timeline-element-subtitle">Content Writing</h4>
                    <p>
                        Worked for 2 Clients
                    </p>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date={"11/2021 - Present"}
                    contentStyle={{
                        border: "1px solid transparent",
                        backgroundColor: "transparent",
                        textAlign: "center",
                        boxShadow: "0 0 5px deeppink, 0 0 30px deeppink"
                    }}
                    textClassName="timeline_txt"
                    contentArrowStyle={{
                        borderRight: "16px solid  white",
                    }}
                    iconStyle={{
                        backgroundColor: '',
                        color: `deeppink`,
                    }}
                    icon={<WorkIcon />}
                >
                    <h3 className="vertical-timeline-element-title">Masai School</h3>
                    <h4 className="vertical-timeline-element-subtitle">Bengaluru, Karnataka</h4>
                    <p>
                        Full Stack Web Development
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    iconStyle={{ background: 'black', color: 'red' }}
                    icon={<StarRateIcon />}
                />

            </VerticalTimeline> */}
    </div>
  );
};
